import { useNuxtApp } from "#imports"
import { defineStore } from "pinia"

export const useToasterStore = defineStore("ToasterStore", {
  persist: {
    storage: persistedState.localStorage,
  },
  state: () => ({
    position: 'top end',
    fillColor: 'primary',
    timeout: 2500,
    title: '',
    msg: '',
    isSnackbarVisible: false,
  }),
  actions: {
    showToast({ title, content, color, position = 'top end' }) {
      this.title = useNuxtApp().$i18n.te(title) ? useNuxtApp().$i18n.t(title) : title
      this.fillColor = color
      this.msg = useNuxtApp().$i18n.te(content) ? useNuxtApp().$i18n.t(content) : content
      this.isSnackbarVisible = true
      this.position = position
    },
    toastSuccess() {
      this.showToast({
        title: 'ajaxokTitle',
        content: 'ajaxokContent',
        color: 'success',
      })
    },
    toastInfoDanger(title, content) {
      this.showToast({ title, content, color: 'error' })
    },
    toastInfoInfo(title, content) {
      this.showToast({ title, content, color: 'info' })
    },
    toastInfoSuccess(title, content) {
      this.showToast({ title, content, color: 'success' })
    },
    toastSimpleWarning(title, content) {
      this.showToast({ title, content, color: 'warning' })
    },
    toastInfoWarning(title, content) {
      this.showToast({ title, content, color: 'warning' })
    },
    toastSimpleError(val) {
      this.toastInfoDanger('ajaxfail', val)
    },
    toastMultipleErrors(errors) {
      Object.entries(errors).forEach(([field, msg]) => {
        const parsedMsg = msg.match(/[^\[\]]+/g)

        const translatedMsg = parsedMsg.length > 1 && parsedMsg[2]
          ? useNuxtApp().$i18n.t(parsedMsg[0], { param: parsedMsg[2] })
          : useNuxtApp().$i18n.t(parsedMsg[0])

        const content = `
          <p>
            ${useNuxtApp().$i18n.t('ajaxfailFieldError')}
            <strong>${useNuxtApp().$i18n.t(field)}</strong>
            <br/>
            ${translatedMsg}
          </p>
        `
    
        this.showToast({ title: 'ajaxfailTitle', content, color: 'error' })
      })
    },
    toastErrors(val) {
      const { message, status } = val._data

      let data

      try {
        data = typeof val._data === 'string' ? JSON.parse(val._data) : val._data
      } catch (e) {
        data = { error: 'unknown_error', messages: { error: 'An unknown error occurred.' } }
      }

      if (data.data) {
        data = { ...data, ...data.data }
      }

      if (data.status === 400) {
        if (data.error) {
          this.toastInfoDanger('ajaxfailTitle', data.messages?.error ?? data.error)
        } else if (data.errors) {
          this.toastMultipleErrors(data.errors)
        }  else{
          this.toastInfoDanger('ajaxfailTitle', data)
        }
      } else if (data.status !== 200) {
        this.toastInfoDanger('ajaxfailServerTitle', 'contactAdmin')
      }
    },

    /*
    toastInfoPrimary(title, content){
      this.showToast({ title, content, color: 'primary' });
    },
    toastInfoSecondary(title, content){
      this.showToast({ title, content, color: 'secondary' });
    }
    */
  },
})
